export function getActiveGuideData(siteSeeGuideId, siteSeeGuideData, isMobile) {
  if (!siteSeeGuideData) return null;

  // The id is a string.

  // The id is an number.
  let key = null;
  if (typeof siteSeeGuideId === 'number') {
    key = isMobile ? 'mobileIndex' : 'desktopIndex';
  } else {
    key = 'id';
  }

  return siteSeeGuideData.find((guide) => guide[key] === siteSeeGuideId) || null;
}

export function updateSiteSeeModalDims(domRect, siteSeeModalDims, siteSeeGuideId) {
  if (!domRect || !siteSeeModalDims || !siteSeeGuideId) {
    return siteSeeModalDims;
  }

  const selflessDims = siteSeeModalDims?.filter((item) => item.id !== siteSeeGuideId) || [];
  let updatedSiteSeeModalDims = selflessDims || [];

  const previousSelfDim = siteSeeModalDims?.find((item) => item.id === siteSeeGuideId) || {};

  const selfDim = Object.fromEntries([
    ['width', domRect?.width],
    ['top', domRect?.top],
    ['right', domRect?.right],
    ['bottom', domRect?.bottom],
    ['left', domRect?.left],
  ]);

  if (
    previousSelfDim.width === selfDim.width
    && previousSelfDim.top === selfDim.top
    && previousSelfDim.right === selfDim.right
    && previousSelfDim.bottom === selfDim.bottom
    && previousSelfDim.left === selfDim.left
  ) {
    updatedSiteSeeModalDims = siteSeeModalDims;
  } else {
    updatedSiteSeeModalDims.push({ id: siteSeeGuideId, ...selfDim });
  }
  return updatedSiteSeeModalDims;
}

export function assembleStepStyles(
  currentSiteSeeModalDims,
  isMobile,
  styling,
  windowWidth,
  windowHeight,
) {
  const rawModalStyle = {};
  let rawArrowStyle = {};
  if (!isMobile && styling?.align && currentSiteSeeModalDims) {
    rawArrowStyle = {};
    const padding = 45;
    const arrowBorder = '30px solid white';
    const arrowWidth = 30;
    const arrowHeight = 45;
    const {
      width, top, right, bottom, left,
    } = currentSiteSeeModalDims;

    styling.align.forEach((element) => {
      switch (element) {
        case 'top':
          rawModalStyle.top = bottom + padding;
          rawArrowStyle.borderBottom = arrowBorder;
          rawArrowStyle.top = -arrowHeight;
          break;
        case 'bottom':
          rawModalStyle.bottom = windowHeight - top + padding;
          rawArrowStyle.borderTop = arrowBorder;
          rawArrowStyle.bottom = -arrowHeight;
          break;
        case 'left':
          rawModalStyle.left = left + (width / 2) - padding;
          rawArrowStyle.left = padding - (arrowWidth / 2);
          break;
        case 'right':
          rawModalStyle.right = windowWidth - right + (width / 2) - padding;
          rawArrowStyle.right = padding - (arrowWidth / 2);
          break;
        default:
          break;
      }
    });
  }

  return {
    rawModalStyle,
    rawArrowStyle,
  };
}
